<nz-select nzMode="multiple" nzShowSearch nzAllowClear class="cp-label-select" [nzCustomTemplate]="selectedTpl" [nzDisabled]="isDisabled"
           [nzPlaceHolder]="'compositeProducts.labels.select.placeholder' | transloco" [ngModel]="value" (ngModelChange)="select($event)">
  @for (option of options; track option.code) {
    <nz-option nzCustomContent [nzValue]="option.code" [nzLabel]="option.text">
      <span class="cp-dot" [style.background]="colors[option.code] || '#bfbfbf'"></span> {{ option.text }}
      @if (notes[option.code]) {
        <span class="cp-stray">({{ notes[option.code] | transloco }})</span>
      }
    </nz-option>
  }
</nz-select>
<ng-template #selectedTpl let-selected>
  <span class="cp-dot" [style.background]="colors[selected.nzValue] || '#bfbfbf'"></span> {{ selected.nzLabel }}
  @if (notes[selected.nzValue]) {
    <span class="cp-stray">({{ notes[selected.nzValue] | transloco }})</span>
  }
</ng-template>
<div class="cp-label-select__hint">
  {{ 'compositeProducts.labels.select.hint' | transloco }}
  <a routerLink="/composite-products/labels">{{ 'compositeProducts.tabs.labels' | transloco }}</a>
</div>
